import styles from './QuestionBlock.module.scss';
import { useNavigate } from 'react-router';
import { AnswerBlock } from '../../../../components/AnswerBlock/AnswerBlock';
import { AnswerItem } from '../../../../components/AnswerItem/AnswerItem';
import { Subtitle } from '../../../../components/Subtitle/Subtitle';
import { useUserData } from '../../../../providers/UserDataProvider/useUserData';
import { Image } from '../../../../components/Image/Image';
import cn from 'classnames';
import { ampScreenCompleted } from '../../../../utils/AmplitudeEvents';
export const QuestionBlock = ({ content, nextSlug }) => {
  const { userData, setUserData } = useUserData();
  const navigate = useNavigate();
  const { title,style, subtitle, answers, slug, background } = content;
  const key = title || `question_${slug}`;
  const currentAnswer = userData?.answers?.[key];
  return (
    <div className={styles.section}>
      <div className={styles.head}>
        {title && <div className={cn(
          styles.titleBlock,
          !background && styles.fullWidht
        )} dangerouslySetInnerHTML={{ __html:title }}/>}
        {subtitle && <Subtitle >{subtitle}</Subtitle>}
        {background && <Image src={background} className={styles.background} />}
      </div>
      {answers &&
        <AnswerBlock
        className={cn(
          styles.answers,
          style === 'grid' && styles.grid
        )}
        >
          {answers.map((box, index) => (
            <AnswerItem
              key={index}
              type={"button"}
              status={currentAnswer === box.answer ? 'active' : null}
              className={cn(
                styles.answer,
                style === 'grid' && styles.gridItem
              )}
              onClick={() => {
                // Узнаём предыдущий выбранный ответ (если был)
                const prevAnswer = userData?.answers?.[key];
                // Находим points старого ответа (если есть)
                const prevObj = answers.find(a => a.answer === prevAnswer);
                const prevE = prevObj?.points?.E ?? 0;
                const prevP = prevObj?.points?.P ?? 0;
              
                // Новые баллы за текущий ответ
                const answerE = box.points?.E ?? 0;
                const answerP = box.points?.P ?? 0;
              
                // Считаем новые total баллы:
                const totalE = (userData?.points?.E || 0) - prevE + answerE;
                const totalP = (userData?.points?.P || 0) - prevP + answerP;
              
                setUserData({
                  ...userData,
                  answers: {
                    ...userData.answers,
                    [key]: box.answer,
                  },
                  points: {
                    E: totalE,
                    P: totalP,
                  },
                });
                ampScreenCompleted(slug,title ||null, box.answer)
                setTimeout(() => {
                  navigate(nextSlug);
                }, 500);
              }}
              
            >
              {box}
            </AnswerItem>
          ))}
        </AnswerBlock>
      }
    </div >
  )
}
